<template>
  <div>
    <p class="bold mb-1">{{ label }}</p>
    <div>
      <span>Months (0-60)</span>
      <input class="input ml-2" :value="value" type="number" @input="$emit('input', $event.target.value)" />
    </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'label']
}
</script>

<style lang="scss" scoped>
.input {
  box-sizing: border-box;
  width: 88px;
  padding: 5px;
  border: 1px solid #b0b3b6;
  background-color: #ffffff;
}
</style>